// TODO: @lisilinhart we can probably remove this function in the future
// it's only used in a single place in `arrayUtils` when the "old way" is used

// TODO: @emanuelgsouza we need to add tests and refactor this code to
// understand how it should work to be used in the arrayUtils.find method

import type { BlockContent } from '@/types/content'

export default function decycle(json: BlockContent): unknown {
  const objects: BlockContent[] = [] // Keep a reference to each unique object or array
  const paths: string[] = [] // Keep the path to each unique object or array

  // value could be a BlockContent but also a string, a number, etc.
  return (function derez(value: unknown, path: string): unknown {
    let i: number // The loop counter
    let nu: unknown // The new object or array

    if (
      typeof value === 'object' &&
      value !== null &&
      !(value instanceof Boolean) &&
      !(value instanceof Date) &&
      !(value instanceof Number) &&
      !(value instanceof RegExp) &&
      !(value instanceof String)
    ) {
      // @ts-expect-error so probably here we should check if value is a BlockContent
      i = objects.indexOf(value)
      if (i >= 0) {
        return { $ref: paths[i] }
      }

      // @ts-expect-error value should be a BlockContent
      objects.push(value)
      paths.push(path)

      if (Array.isArray(value)) {
        nu = []
        value.forEach(function (element, i) {
          // @ts-expect-error ensure nu is an array
          nu[i] = derez(element, path + '[' + i + ']')
        })
      } else {
        nu = {}
        Object.keys(value).forEach(function (name) {
          // @ts-expect-error ensure name is a key of BlockContent
          nu[name] = derez(value[name], path + '[' + JSON.stringify(name) + ']')
        })
      }
      return nu
    }
    return value
  })(json, '$')
}
